import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {auth} from 'main/tools';
import AccrualForm from './AccrualForm';
import CarryoverForm from './CarryoverForm';
import VacationPayoutForm from './VacationPayoutForm';
import FlexibleForm from './FlexibleForm';
import WaitingPeriodForm from './WaitingPeriodForm';
import NegativeBalancesForm from './NegativeBalancesForm';
import ApprovalForm from './ApprovalForm';
import {Panel, FormLayout, RadioButtonGroup, RadioButton, PanelRadioButton} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import PolicyConfirmationModal from '../PolicyConfirmationModal';
import useModal from 'shared/hooks/useModal';

const TimeOffRules = observer(({uiState, submitStep}) => {
  const policyConfirmationModalOpen = useModal(uiState, 'PolicyConfirmationModal');
  const {policy, typePolicy, accrualType} = uiState;

  return (
    <div>
      <Panel.Stack loose>
        <Panel>
          <Panel.Header title={t('time_off.policy.edit.ACCRUAL_SETTINGS', {type: typePolicy.type.name})}/>
          <RadioButtonGroup
            className={'table'}
            name='accrualType'
            selectedValue={accrualType}
            onChange={(name, value) => uiState.selectAccrualType(value)}
          >
            <PanelRadioButton
              value='standard'
              label='time_off.policy.edit.Standard'
              description='time_off.policy.edit.STANDARD_EXPLANATION'
              onClick={() => uiState.accrualType = 'standard'}
              isActive={accrualType === 'standard'}
            >
              <AccrualForm uiState={uiState}/>
              <CarryoverForm uiState={uiState}/>
            </PanelRadioButton>
            <PanelRadioButton
              value='unlimited'
              label='time_off.policy.edit.Flexible'
              description='time_off.policy.edit.FLEXIBLE_EXPLANATION'
              onClick={() => uiState.accrualType = 'unlimited'}
              isActive={accrualType === 'unlimited'}
            >
              <FlexibleForm uiState={uiState}/>
            </PanelRadioButton>
            {typePolicy.type.vacation && auth.company.showNmbrPayroll && auth.company.nmbrVacationPayEnabled && <PanelRadioButton
              value='vacation_payout'
              label='time_off.policy.edit.Vacation Payout'
              description='time_off.policy.edit.VACATION_PAYOUT_EXPLANATION'
              onClick={() => uiState.accrualType = 'vacation_payout'}
              isActive={accrualType === 'vacation_payout'}
            >
              <VacationPayoutForm uiState={uiState}/>
            </PanelRadioButton>}
          </RadioButtonGroup>
        </Panel>
        <WaitingPeriodForm uiState={uiState}/>
        {accrualType !== 'unlimited' && <NegativeBalancesForm uiState={uiState}/>}
        <Panel>
          <Panel.Header title={t('time_off.policy.edit.MINIMUM_TIME_OFF_INCREMENT', {type: typePolicy.type.name})}/>
          <FormLayout>
            <div className='waterloo'>
              <FormattedMessage id='time_off.policy.edit.MINIMUM_TIME_OFF_INCREMENT_EXPLANATION'/>
            </div>
            <RadioButtonGroup
              name='minimumRequestIncrement'
              selectedValue={typePolicy.minimumRequestIncrement}
              onChange={(name, value) => typePolicy.merge({minimumRequestIncrement: value})}
            >
              <RadioButton className='full-width' value='any'><FormattedMessage id='time_off.policy.edit.Full days, half days, or custom hours'/></RadioButton>
              <RadioButton className='full-width' value='half_day'><FormattedMessage id='time_off.policy.edit.Full days or half days'/></RadioButton>
              <RadioButton className='full-width' value='full_day'><FormattedMessage id='time_off.policy.edit.Full days only'/></RadioButton>
            </RadioButtonGroup>
          </FormLayout>
        </Panel>
        <ApprovalForm uiState={uiState}/>
      </Panel.Stack>
      <PolicyConfirmationModal
        uiState={uiState}
        description="time_off.policy.edit.Choose when you'd like the changes to take effect and preview how they will impact employee balances."
        isOpen={policyConfirmationModalOpen}
        employees={policy.employees}
        onSave={submitStep}
        updateForecast={() => uiState.forecastTypePolicy()}
      />
    </div>
  );
});

export default TimeOffRules;
